
        var result = require("!!../../../node_modules/css-loader/index.js?-url&minimize!../../../node_modules/sass-loader/lib/loader.js!./landingpage.component.scss");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/landingpage/landingpage.component.scss
// module id = 158
// module chunks = 6